import React from "react";
import styles from "./Filters.module.scss";
import { INDUSTRY_MAPPINGS } from "./FilterMappings";
import { ICON_MAPPINGS } from "./FilterMappings";
export default function Industrytype(props) {

    const { currentIndustryType, setCurrentIndustryType } = props
    const type = INDUSTRY_MAPPINGS;

    const selectIndustryType = (key) => {
        if (currentIndustryType === key) {
            return setCurrentIndustryType(0)
        }

        setCurrentIndustryType(key)
    }

    function mapIcon(key) {
        const mapping =  ICON_MAPPINGS.find((mapping) => key === mapping.key)
        return mapping.icon
    }
    return (
        <>
            <div className={styles.formSection}>
                <h3>Industry Type</h3>
                <div className={styles.verticaloffsetmedium}>Adding an industry filter may help you find an advisor who understands the specific financial nuances, challenges, and opportunities unique to your field.</div>
                <div className={styles.industryTypesContainer}>
                    {type.map((item) => {
                        return <div className={currentIndustryType === item.key ? styles.industryTypeSelected : styles.industryType} key={item.key} onClick={() => selectIndustryType(item.key)}>{mapIcon(item.icon)}{item.text}</div>
                    })}
                </div>
            </div>
        </>
    )
}